// https://github.com/shoelace-style/shoelace/blob/next/src/internal/event.ts
//
// Emits a custom event with more convenient defaults.
//
export function emit(el, name, options) {
    const event = new CustomEvent(name, Object.assign({
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {},
    }, options));
    el.dispatchEvent(event);
    return event;
}
//
// Waits for a specific event to be emitted from an element. Ignores events that bubble up from child elements.
//
export function waitForEvent(el, eventName, listenOnce = false) {
    return new Promise((resolve) => {
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve(event.detail);
            }
        }
        el.addEventListener(eventName, done, { once: listenOnce });
    });
}
export function modalToggleEvent(_this, event) {
    _this.dispatchEvent(new CustomEvent('modal.toggle', {
        bubbles: true,
        composed: true,
        detail: { modalToggle: _this.isModalToggle, modalTarget: _this.modalTarget, event },
    }));
}
//# sourceMappingURL=event.js.map